// extracted by mini-css-extract-plugin
export default {"options":"board_options__j17r5","board":"board_board__phlpR","head":"board_head__f6em-"};